window.App = window.App || {};
window.App.modules = window.App.modules || {};

window.App.modules["footer-accordion"] = (el) => {
  let isInit = false;
  let clickHandler = null;

  const init = () => {
    if (isInit) return;
    isInit = true;

    clickHandler = (e) => {
      const trigger = e.target.closest('[data-dc-action="toggle"]');
      if (!trigger || !el.contains(trigger)) return;

      const targetType = trigger.dataset.dcOptionTarget;
      if (targetType !== "next") return;

      const content = trigger.nextElementSibling;
      if (!content) return;

      const parent = trigger.closest(".menu_link");
      parent.classList.toggle("on");

      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    };

    el.addEventListener("click", clickHandler);
  };

  const destroy = () => {
    if (!isInit) return;
    el.removeEventListener("click", clickHandler);
    isInit = false;
  };

  return { init, destroy };
};

function footerChatHandler(){
  const chatButton = document.querySelector('.footer-contact__chat');

  if (chatButton) {
    chatButton.addEventListener('click', function (e) {
      e.preventDefault();
      if (window.ChannelIO) {
        window.ChannelIO('showMessenger');
      }
    });
  }
}

// footerChatHandler();